import { type ComponentPropsWithRef, forwardRef } from 'react';

import { cn } from '@air/utils-tailwind';

import { type TEXTAREA_ELEMENT_TAG, TEXTAREA_SIZE_CLASSES, type TextareaSize, textareaClasses } from './constants';

export type TextareaProps = Omit<ComponentPropsWithRef<typeof TEXTAREA_ELEMENT_TAG>, 'size'> & {
  /**
   * This allows the textarea to grow in height to fit the content.
   * Please note that this is not fully supported by all browsers.
   */
  autoGrow?: boolean;
  size?: TextareaSize;
  hasError?: boolean;
};

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, autoGrow = false, hasError, rows = 3, size = 'medium', style, ...restOfProps }, forwardedRef) => {
    return (
      <textarea
        className={cn(
          textareaClasses,
          TEXTAREA_SIZE_CLASSES[size],
          hasError && '!border-red-9 !ring-red-9 ring-1 focus:ring-red-9',
          className,
        )}
        ref={forwardedRef}
        rows={rows}
        style={{
          ...style,
          // @ts-expect-error - fieldSizing is a valid property on modern browsers, but not on older ones. TypeScript has not updated the type to include this.
          fieldSizing: autoGrow ? 'content' : 'none',
        }}
        {...restOfProps}
      />
    );
  },
);

Textarea.displayName = 'Textarea';
